import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { LayoutDashboard, FilePlus, History, Settings, X } from "lucide-react";
import MLogo from "../assets/images/Momentum Logo M.png";
import { Guid } from "js-guid";

export default function QuoteProposalSidebar(props: any) {
  return (
    <div className="start-0 border-end bg-white shadow quote-proposal-sidebar">
      <div className="d-flex align-items-center justify-content-between border-bottom p-3">
        <Link to="" className="d-flex align-items-center gap-2 text-decoration-none hide-cursor">
          <span className="bg-white">
            <img src={MLogo} height={20} />
          </span>
          <div className="position-relative">
            <span className="text-purple fs-5 fw-bold">Quote Proposal</span>
            <span className="badge bg-warning text-dark position-absolute" style={{ top: "-8px", right: "-40px", fontSize: "0.6rem" }}>
              Beta
            </span>
          </div>
        </Link>
        <Button icon={<X size={18} />} className="d-md-none btn btn-sm p-button-text" />
      </div>

      <nav className="mt-2 p-3">
        <ul className="nav flex-column gap-2">
          <li className="nav-item">
            <Link
              to="/quoteproposaldashboard"
              className={`nav-link d-flex align-items-center rounded px-3 py-2 hover-bg
                ${props.pagename == "proposal-dashboard" ? "bg-purple text-purple " : " text-dark"}`}
            >
              <LayoutDashboard size={18} className="me-2" />
              Dashboard
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to={`/newquoteproposal/${Guid.newGuid()}`}
              className={`nav-link d-flex align-items-center rounded px-3 py-2 hover-bg
                ${props.pagename == "proposal-landingpage" ? "bg-purple text-purple" : " text-dark"}`}
            >
              <FilePlus size={18} className="me-2" />
              New Proposal
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/proposalhistory"
              className={`nav-link d-flex align-items-center rounded px-3 py-2 hover-bg
                ${props.pagename == "proposal-history" ? "bg-purple text-purple" : " text-dark"}`}
            >
              <History size={18} className="me-2" />
              History
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/proposalsettings"
              className={`nav-link d-flex align-items-center rounded px-3 py-2 hover-bg
                ${props.pagename == "proposal-settings" ? "bg-purple text-purple" : " text-dark"}`}
            >
              <Settings size={18} className="me-2" />
              Settings
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}
